/// //////////////////////////////////////////////////////////////////////////
//                                                                          //
//  本文件由WIDE自动生成框架，用来定义类似webcomponent的元素．                     //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// //////////////////////////////////////////////////////////////////////////
// Created At : 2018-12-17T07:41:02.479Z

'use strict'

// 封装在wwimport，以防止在wwjs加载完成之前加载．通常是不必要的．

wwimport('ready', () => {
  function onLoadErr (errFiles) {
    console.error(`X-editable依赖文件加载错误`)
  }
  /**
  请在这里写入元素作用的简单描述．
  @class Xeditable
  @extends wwjs.wwclass
  */
  @wwjs.wwclass.dep(['!css:@/X-editable/1.5.3/bootstrap4-editable/css/bootstrap-editable.css', '@/X-editable/1.5.3/bootstrap4-editable/js/bootstrap-editable.min.js'], onLoadErr)
  class Xeditable extends wwjs.wwclass {
    static version = '<# VERSION #>'
    constructor (ele) {
      super(ele)
      // 是否处于可编辑状态,当状态变化时，触发编辑状态变化。
      wwjs.wwclass.watch('data-state')
      // 值绑定，编辑后更新值，以及同步三个状态。
      wwjs.wwclass.watch('value')
      // 其它属性不监控，只是读取。

      // 初始化editable元素。
    }
    onstateChanged (oldValue) {
    }
    finalize () {
      // 这里写自己的析构代码
    }
    doRender () {
      // 如果没有绘制部分，请删除本函数．
      return this.render`<!-->这里是自己的模板代码<--!>`
    }
  }
  wwjs.wwclass.reg('xeditable', Xeditable)
})
